var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDetail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_345)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.2 15.2L11.7256 11.7256M11.7256 11.7256C12.3199 11.1313 12.7913 10.4257 13.113 9.64921C13.4346 8.8727 13.6001 8.04045 13.6001 7.19997C13.6001 6.35949 13.4346 5.52724 13.113 4.75073C12.7913 3.97423 12.3199 3.26868 11.7256 2.67437C11.1313 2.08006 10.4257 1.60863 9.64921 1.28699C8.8727 0.96535 8.04045 0.799805 7.19997 0.799805C6.35949 0.799805 5.52724 0.96535 4.75073 1.28699C3.97423 1.60863 3.26868 2.08006 2.67437 2.67437C1.47411 3.87463 0.799805 5.50254 0.799805 7.19997C0.799805 8.8974 1.47411 10.5253 2.67437 11.7256C3.87463 12.9258 5.50254 13.6001 7.19997 13.6001C8.8974 13.6001 10.5253 12.9258 11.7256 11.7256ZM7.19997 4.79997V9.59997M4.79997 7.19997H9.59997",
    stroke: "#474973",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_345"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetail);
export default __webpack_public_path__ + "static/media/Detail.ff01f44365a79e74789ad013794c884d.svg";
export { ForwardRef as ReactComponent };